// app/javascript/controllers/quantity_selection_controller.js

import { Controller } from '@hotwired/stimulus'

const TARGET_AVAILABLE_QUANTITY       = 'availableQuantity'
const TARGET_SPECIFIED_QUANTITY       = 'specifiedQuantity'
const TARGET_CRATE_ITEM_VALUE         = 'crateItemValue'
const TARGET_GEAR_ITEM_VALUE          = 'gearItemValue'
const TARGET_LINE_ITEM                = 'lineItem'
const TARGET_ROUND_COUNT_SUBTOTAL     = 'roundCountSubtotal'
const TARGET_VALUE_SUBTOTAL           = 'valueSubtotal'
const TARGET_GEAR_SUBTOTAL            = 'gearSubtotal'
const TARGET_PROGRESS_VALUE_SUBTOTAL  = 'progressvalueSubtotal'
const TARGET_PROGRESS_TEXT            = 'progressText'
const TARGET_FREEE_SHIPPING_VALUE     = 'freeShippingValue'
const TARGET_PROGRESS_STYLE           = 'progressStyle'
const TARGET_ZERO_BUTTON              = 'zeroButton'
const TARGET_MAX_BUTTON               = 'maxButton'
const TARGET_CONTINUE_BUTTON          = 'continueButton'

// The old ID attribute was for crates only; now we also define gear:
const DATA_CRATE_ITEM_ID = 'quantitySelectionCrateItemIdValue'
const DATA_GEAR_ITEM_ID  = 'quantitySelectionGearItemIdValue'

export default class extends Controller {
  static targets = [
    TARGET_LINE_ITEM,
    TARGET_SPECIFIED_QUANTITY,
    TARGET_CRATE_ITEM_VALUE,
    TARGET_GEAR_ITEM_VALUE,
    TARGET_ROUND_COUNT_SUBTOTAL,
    TARGET_VALUE_SUBTOTAL,
    TARGET_GEAR_SUBTOTAL,
    TARGET_PROGRESS_VALUE_SUBTOTAL,
    TARGET_PROGRESS_TEXT,
    TARGET_FREEE_SHIPPING_VALUE,
    TARGET_PROGRESS_STYLE,
    TARGET_ZERO_BUTTON,
    TARGET_MAX_BUTTON,
    TARGET_CONTINUE_BUTTON
  ]

  static values = {
    url: String
  }

  crateQuantityChanged(event) {
    const itemId = this.crateItemIdFrom(event.target)
    const quantity = event.target.value
    // Build the "basket" just for crates or for everything (your choice):
    const updatedBasketState = this.updatedBasketState()

    this.sendUpdateRequest({
      itemId,
      itemType: 'crate',
      selectedQuantity: quantity
    }, updatedBasketState)
  }

  crateItemIdFrom(element) {
    const lineItem = $(element).closest(
      `[data-quantity-selection-target="${TARGET_LINE_ITEM}"]`
    )
    return lineItem.data(DATA_CRATE_ITEM_ID)
  }

  gearQuantityChanged(event) {
    const itemId = this.gearItemIdFrom(event.target)
    const quantity = event.target.value
    // Build the "basket" just for gear or for everything (your choice):
    const updatedBasketState = this.updatedBasketState()

    this.sendUpdateRequest({
      itemId,
      itemType: 'gear',
      selectedQuantity: quantity
    }, updatedBasketState)
  }

  gearItemIdFrom(element) {
    const lineItem = $(element).closest(
      `[data-quantity-selection-target="${TARGET_LINE_ITEM}"]`
    )
    return lineItem.data(DATA_GEAR_ITEM_ID)
  }

  updatedBasketState() {
    const lineItems = document.querySelectorAll('[data-quantity-selection-target="lineItem"]');
    return Array.from(lineItems).map(lineItem => {
      const availableQuantity = $(lineItem).find(
        `[data-quantity-selection-target="${TARGET_AVAILABLE_QUANTITY}"]`
      ).text().trim();

      const specifiedQuantity = $(lineItem).find('select')
        .find('option:selected')
        .val();

      const crateItemId = $(lineItem).data(DATA_CRATE_ITEM_ID);
      const gearItemId  = $(lineItem).data(DATA_GEAR_ITEM_ID);

      let itemId, itemType;
      if (gearItemId) {
        itemId = gearItemId;
        itemType = 'gear';
      } else {
        itemId = crateItemId;
        itemType = 'crate';
      }

      return {
        itemId,
        itemType,
        availableQuantity,
        specifiedQuantity
      };
    });
  }

  sendUpdateRequest(changeObj, updatedBasketState) {
    const basketUpdateUrl = this.urlValue
    if (!basketUpdateUrl) {
      console.error("No URL available for quantity-selection!")
      return
    }

    const otherCrateIdsStr = $('#crate_ids').val() || ""

    const params = new URLSearchParams({
      otherCrateIdsStr,
      updatedBasketState: JSON.stringify(updatedBasketState),
      change: JSON.stringify(changeObj)
    })

    const fetchUrl = `${basketUpdateUrl}?${params}`

    fetch(fetchUrl, { method: 'GET' })
      .then(resp => {
        if (!resp.ok) {
          throw new Error(`Request failed: status ${resp.status}`)
        }
        return resp.json()
      })
      .then(data => {
        this.updateDomFromResponse(data)
      })
      .catch(error => {
        console.error("Error updating quantity:", error)
      })
  }

  updateDomFromResponse(data) {
    data.rows.forEach(row => {
      const { updatedValue, itemId, itemType } = row;
      let rowSelector, valueTarget;
      if (itemType === 'crate') {
        rowSelector = `[data-quantity-selection-crate-item-id-value="${itemId}"]`;
        valueTarget = TARGET_CRATE_ITEM_VALUE;
      } else {
        rowSelector = `[data-quantity-selection-gear-item-id-value="${itemId}"]`;
        valueTarget = TARGET_GEAR_ITEM_VALUE;
      }
      $(rowSelector)
        .find(`[data-quantity-selection-target="${valueTarget}"]`)
        .text(updatedValue);
    });

    if (data.subtotals) {
      if (this.hasValueSubtotalTarget) {
        $(this.valueSubtotalTarget).text(data.subtotals.crateValue);
      }
      if (this.hasGearSubtotalTarget) {
        $(this.gearSubtotalTarget).text(data.subtotals.gearValue);
      }
      this.updateProgessBar({
        subtotals: {
          value: data.subtotals.totalValue
        }
      });
    }
  }


  updateProgessBar(data){
    // data.subtotals.value is our total dollar amount as a currency string (e.g. "$29.99")
    $(`[data-quantity-selection-target="${TARGET_PROGRESS_VALUE_SUBTOTAL}"]`).text(data.subtotals.value)

    const totalValue = parseFloat(data.subtotals.value.replace(/[^0-9.-]+/g, '')) || 0
    const freeValueText = $(`[data-quantity-selection-target="${TARGET_FREEE_SHIPPING_VALUE}"]`).text()
    const freeValue = parseFloat(freeValueText.replace(/[^0-9.]/g, '')) || 0

    const progressTextElement = $(`[data-quantity-selection-target="${TARGET_PROGRESS_TEXT}"]`)
    const progressStyleElement = $(`[data-quantity-selection-target="${TARGET_PROGRESS_STYLE}"]`)

    const continuebtn = $(`[data-quantity-selection-target="${TARGET_CONTINUE_BUTTON}"]`);

    if (totalValue >= freeValue) {
      progressTextElement.html(`Congratulations you qualify for <strong class='font-semibold'>Free Shipping!</strong>`)
      progressStyleElement.css('grid-template-columns', '100fr 0fr')
    } else {
      const remainingValue = freeValue - totalValue
      progressTextElement.html(`You're only <strong class='font-semibold'>$${remainingValue.toFixed(2)}</strong> away from <strong class='font-semibold'>Free Shipping!</strong>`)
      progressStyleElement.css('grid-template-columns', `${totalValue}fr ${remainingValue}fr`)
    }
    if (totalValue == 0.0) {
      continuebtn.prop("disabled",true);
      continuebtn.removeClass('cursor-pointer bg-yellow-400 hover:bg-yellow-500').addClass('text-gray-400 bg-gray-200')
    } else {
      continuebtn.prop("disabled",false);
      continuebtn.addClass('cursor-pointer bg-yellow-400 hover:bg-yellow-500').removeClass('text-gray-400 bg-gray-200')
    }
  }

  // The rest of your “zeroButton”, “maxButton” methods remain the same,
  // as they simply call “quantityChanged” on each select.
  zeroButton(event){
    event.preventDefault();
    this.updateButtonStyles(event, TARGET_MAX_BUTTON, true);
    this.setAllAmmoQuantitiesToMin();
  }

  maxButton(event) {
    event.preventDefault();
    this.updateButtonStyles(event, TARGET_ZERO_BUTTON, false);
    this.setAllAmmoQuantitiesToMax();
  }

  getButtonClasses(isZeroButton) {
    const activeClass = "text-gray-900 bg-yellow-500 hover:bg-yellow-600";
    const inactiveClass = "hover:bg-white hover:text-gray-900 font-medium";
    return { active: activeClass, inactive: inactiveClass };
  }

  updateButtonStyles(event, targetButtonSelector, isZeroButton) {
    const { active, inactive } = this.getButtonClasses(isZeroButton);
    $(event.target).removeClass(inactive).addClass(active);
    $(`[data-quantity-selection-target="${targetButtonSelector}"]`)
      .removeClass(active)
      .addClass(inactive);
  }

  setAllAmmoQuantitiesToMin() {
    this.specifiedQuantityTargets.forEach(container => {
      // Skip gear items if this container has a hidden input with "gear_item_id" in its name
      if (container.querySelector('input[name*="gear_item_id"]')) {
        return;
      }
      const select = container.querySelector("select");
      if (select) {
        const minOption = Array.from(select.options).find(option => option.value === "0");
        select.value = minOption ? minOption.value : select.options[0].value;
      }
    });
    this.sendBatchUpdate();
  }

  setAllAmmoQuantitiesToMax() {
    this.specifiedQuantityTargets.forEach(container => {
      // Skip gear selects if a hidden input with "gear_item_id" exists in the container
      if (container.querySelector('input[name*="gear_item_id"]')) {
        return;
      }
      const select = container.querySelector("select");
      if (select) {
        const options = select.options;
        if (options.length > 0) {
          select.value = options[options.length - 1].value;
        }
      }
    });
    this.sendBatchUpdate();
  }

  sendBatchUpdate() {
    const allBasketState = this.updatedBasketState();
    const changeObj = { batchUpdate: true };
    this.sendUpdateRequest(changeObj, allBasketState);
  }
}
